import { baseURlFront } from "../config"
import he from "he";

export const fixImagePaths = (htmlContent) => {
    if (!htmlContent) return "";
    let t = htmlContent.replace(/src="assets\//g, `src="${baseURlFront}/assets/`);
    t = t.replace(/'assets\//g, `'${baseURlFront}/assets/`);
    return t
};

export const fetchRelaPro =(products, cat, subcat, prod)=>{
    const extractedProducts = [];
        products && products.categories && products.categories.forEach((category) => {
          if (category.categorySlug === cat) {
            category.subCat && category.subCat.forEach((subCategory) => {
            //   if (subCategory.subCategorySlug === subcat && subCategory.products?.length > 0) {
                extractedProducts.push(...subCategory.products);
            //   }
            });
            if (category.products) {
              extractedProducts.push(...category.products);
            }
          }
  
        });
  
        return extractedProducts.filter(pro => pro.productSlug != prod);
  
  
  }

  export const decodeHtml = (htmlContent) => {
  const decodedHtml = he.decode(htmlContent);

  // if (!htmlContent) return "";
  // let t = htmlContent.replace(/src="static\//g, `src="${BASE_URL}/assets/`);
  // t = t.replace(/'assets\//g, `'${BASE_URL}/assets/`);
  return decodedHtml;
};